// extracted by mini-css-extract-plugin
export default {"container":"Land_container__OPRFq","header":"Land_header__WsvSG","img":"Land_img__uC8+A","label":"Land_label__KkyJ5"};